<p-toast position="top-right" key="notification-message"></p-toast>
<p-dialog [(visible)]="displayNotificationDialog" [blockScroll]="true" [modal]="true"
          [showHeader]="false"
          [draggable]="false"
          class="notifications-dialog"
          [style]="{width: '80%'}">
    <div class="p-grid p-my-2 ">
        <div class="p-col-2">

        </div>
        <div class="p-text-primary p-text-bold p-col">
            <h5 class="p-m-0">Filter</h5>
        </div>
    </div>
    <div class="p-grid p-hover-filter p-cursor p-mt-0 p-mb-1 p-py-0 "
         [class]="selectedFilterStatus === filterOption ? 'p-selected-filter' : ''"
         *ngFor="let filterOption of filterStatusArray"
         (click)="applyStatusFilter(filterOption); displayNotificationDialog = false">
        <div class="p-col-2 p-pl-0 p-col-align-center p-text-right p-pr-3">
            <img *ngIf="selectedFilterStatus === filterOption"
                 src="assets/branding/notifications/selected-notification-filter.svg"
                 style="height: calc(0.80rem + 0.35vmin);">
        </div>
        <div [class]="selectedFilterStatus === filterOption ? 'p-col-10 p-py-3 p-pr-0 p-text-bold' : 'p-col-10 p-py-3 p-pr-0 fp-text-bold'">
            {{filterOption}}
        </div>
    </div>
</p-dialog>


<div class="p-grid p-jc-xl-around p-mt-2">
    <div class="p-col-11">
        <div class="card p-pl-2 p-pr-0 table-border p-py-0">
            <div class="grid p-d-flex">
                <div class="p-col-12 p-md-9 p-px-3">
                    <div class="p-grid">
                        <div class="p-col-12 p-mb-3 p-py-3 p-border-bottom">
                            <div class="p-d-flex p-ai-center p-jc-between">
                                <h5 class="p-text-primary p-my-0">
                                    Notification ({{selectedFilterStatus}})
                                </h5>
                                <div>
                                    <button (click)="markAllNotificationsAsRead()" pButton pRipple label="Clear All"
                                            class="p-button-secondary p-button-sm"></button>
                                </div>
                                <div class="p-d-block p-d-md-none ">
                                    <img (click)="displayNotificationDialog = true"
                                         src="assets/branding/notifications/notification-filter.svg"
                                         class="fp-icon-height p-cursor">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-grid" *ngIf="pagedNotification?.totalElements <= 0">
                        <div class="p-col-12 p-text-bold p-text-center p-py-5" style="min-height: 20rem">
                            No Notification Found
                        </div>
                    </div>

                    <div>
                        <div *ngIf="notifications">
                            <div class="p-d-none p-d-xl-block">
                                <div *ngFor="let notification of notifications"
                                     class="fp-notification-list p-jc-evenly p-mt-3 p-p-3">
                                    <div class="p-d-flex p-ai-center p-jc-between width-100">
                                        <div style="width: 95%">
                                            <!--Notification heading-->
                                            <div class="p-grid">
                                                <div class="p-col-2">
                                                    <div class="p-text-secondary p-text-bold">
                                                        Booking Number
                                                    </div>
                                                </div>
                                                <div class="p-col-2">
                                                    <div class="p-text-secondary p-text-bold">
                                                        Transport Document
                                                    </div>
                                                </div>
                                                <div class="p-col-2">
                                                    <div class="p-text-secondary p-text-bold">
                                                        Customer Reference No.
                                                    </div>
                                                </div>
                                                <div class="p-col-2">
                                                    <div class="p-text-secondary p-text-bold">
                                                        Booking Date
                                                    </div>
                                                </div>
                                                <div class="p-col-2">
                                                    <div class="p-text-secondary p-text-bold">
                                                        Status
                                                    </div>
                                                </div>
                                            </div>
                                            <!--Notification Data-->
                                            <div class="p-grid">
                                                <div class="p-col-2">
                                                    <div [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                                                         class="p-text-bold p-mt-5">
                                                        {{notification?.bookingXid ? notification?.bookingXid : '-'}}
                                                    </div>
                                                </div>
                                                <div class="p-col-2">
                                                    <div class="p-mt-5">
                                                        <div class="p-d-flex p-ai-center p-jc-between">
                                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                                                {{notification?.transportDocument ? notification?.transportDocument : '-'}}
                                                            </div>
                                                            <div class="p-ml-2" *ngIf="notification?.blCount > 0">
                                                                <p-badge
                                                                        [value]="'+' + notification?.blCount"></p-badge>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="p-col-2">
                                                    <div class="p-mt-5"
                                                         [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                                        {{notification?.customerReferenceNumber ? notification?.customerReferenceNumber : '-'}}
                                                    </div>
                                                </div>
                                                <div class="p-col-2">
                                                    <div class="p-mt-5"
                                                         [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                                        {{notification?.bookingDate ? notification?.bookingDate : '-'}}
                                                    </div>
                                                </div>
                                                <div class="p-col-2">
                                                    <div class="p-text-bold p-mt-5"
                                                         [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                                        {{notification?.status ? notification?.status : '-'}}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="p-text-center" style="width: 5%;">
                                            <div *ngIf="!notification?.readStatus" class="p-text-danger p-text-bold">
                                                New !
                                            </div>

                                            <div class="p-mt-2">
                                                <button (click)="markNotificationAsTrue(notification)" pButton pRipple
                                                        icon="pi pi-check-circle"
                                                        [disabled]="notification?.readStatus"
                                                        class="p-button-secondary p-button-text p-button-lg"></button>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="p-d-block p-d-xl-none">
                                <div class="p-grid fp-notification-list p-jc-evenly p-mt-3 p-py-3 p-ai-center"
                                     *ngFor=" let notification of notifications">
                                    <div class="p-col-12 p-d-flex p-ai-center">
                                        <div class="p-text-secondary p-text-bold">
                                            Booking Number
                                        </div>
                                        <div class="p-text-bold p-ml-2">
                                            {{notification?.bookingId ? notification?.bookingId : '-'}}
                                        </div>
                                    </div>
                                    <div class="p-col-12 p-d-flex p-ai-center">
                                        <div class="p-text-secondary p-text-bold">
                                            Transport Document
                                        </div>
                                        <div class="p-ml-2">
                                            <div class="p-d-flex p-ai-center p-jc-between">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'">
                                                    {{notification?.transportDocument ? notification?.transportDocument : '-'}}
                                                </div>
                                                <div class="p-ml-2" *ngIf="notification?.blCount > 0">
                                                    <p-badge [value]="'+' + notification?.blCount"></p-badge>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="p-col-12 p-d-flex p-ai-center">
                                        <div class="p-text-secondary p-text-bold">
                                            Customer Reference No.
                                        </div>
                                        <div class="p-ml-2">
                                            {{notification?.customerReferenceNumber ? notification?.customerReferenceNumber : '-'}}
                                        </div>
                                    </div>
                                    <div class="p-col-12 p-d-flex p-ai-center">
                                        <div class="p-text-secondary p-text-bold">
                                            Booking Date
                                        </div>
                                        <div class="p-ml-2">
                                            {{notification?.bookingDate ? notification?.bookingDate : '-'}}
                                        </div>
                                    </div>
                                    <div class="p-col-12 p-d-flex p-ai-center">
                                        <div class="p-text-secondary p-text-bold">
                                            Status
                                        </div>
                                        <div class="p-text-bold p-ml-2">
                                            {{notification?.status ? notification?.status : '-'}}
                                        </div>
                                    </div>
                                    <div class="p-col-12 p-d-flex p-ai-center p-jc-end">

                                        <div *ngIf="!notification?.readStatus" class="p-text-danger p-text-bold">
                                            New !
                                        </div>

                                        <div class="p-ml-2">
                                            <button (click)="markNotificationAsTrue(notification)" pButton pRipple
                                                    icon="pi pi-check-circle"
                                                    [disabled]="notification?.readStatus"
                                                    class="p-button-secondary p-button-text p-button-lg"></button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div>
                        <p-paginator class="p-mt-3" *ngIf="pagedNotification?.totalElements > 0"
                                     (onPageChange)="paginateFilteredNotification($event)" [rows]="10"
                                     [totalRecords]="pagedNotification?.totalElements"></p-paginator>
                    </div>
                </div>
                <div class="p-col-3 p-d-none p-d-md-block fp-notification-list">
                    <div class="p-grid p-mt-0 p-mb-1 p-py-0 ">
                        <div class="p-col-2">

                        </div>
                        <div class="p-text-primary p-text-bold p-col">
                            Filter
                        </div>
                        <div class="p-col p-py-2 p-pr-5">
                            <img src="assets/branding/notifications/notification-filter.svg" class="fp-icon-height"
                                 style="float: right">
                        </div>
                    </div>
                    <div class="p-grid p-hover-filter p-cursor p-mt-0 p-mb-1 p-py-0 "
                         [class]="selectedFilterStatus === filterOption ? 'p-selected-filter' : ''"
                         *ngFor="let filterOption of filterStatusArray" (click)="applyStatusFilter(filterOption)">
                        <div class="p-col-2 p-pl-0 p-col-align-center p-text-right p-pr-3">
                            <img *ngIf="selectedFilterStatus === filterOption"
                                 src="assets/branding/notifications/selected-notification-filter.svg"
                                 style="height: calc(0.80rem + 0.35vmin);">
                        </div>
                        <div [class]="selectedFilterStatus === filterOption ? 'p-col-10 p-py-3 p-pr-0 p-text-bold' : 'p-col-10 p-py-3 p-pr-0 fp-text-bold'">
                            {{filterOption}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--<div style="overflow: scroll; min-width: 180px; width: 100%">-->
<!--    <div style="width: 180vh; white-space: nowrap">-->
